
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.97 1.97a.75.75 0 011.06 0L8.561 5.5H20a.5.5 0 01.354.854L13 13.706v7.044h1.25c.73 0 1.443.213 2.051.61l.199.14.4.3a.25.25 0 01-.15.45h-9.5a.25.25 0 01-.15-.45l.4-.3a3.75 3.75 0 012.25-.75H11v-7.043L3.646 6.354A.5.5 0 014 5.5h2.439l-2.47-2.47a.75.75 0 01-.072-.976zM7.439 6.5H5.5l3 3h1.939l-3-3zm11.061 0H9.561l3 3H15.5l3-3z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    